const getBoundPositionPercentage = (value: number, boundsMin: number, boundsMax: number) => {
    if (boundsMax <= boundsMin) {
        return 0;
    }

    return Math.round(((value - boundsMin) / (boundsMax - boundsMin)) * 100);
};

export const getYZoomPercentage = (
    selectedMin: number,
    selectedMax: number,
    boundsMin: number,
    boundsMax: number,
) => {
    if (boundsMax <= boundsMin) {
        return 100;
    }

    return Math.round(((selectedMax - selectedMin) / (boundsMax - boundsMin)) * 100);
};

export const isFullYZoomRange = (
    selectedMin: number,
    selectedMax: number,
    boundsMin: number,
    boundsMax: number,
) =>
    getBoundPositionPercentage(selectedMin, boundsMin, boundsMax) === 0 &&
    getBoundPositionPercentage(selectedMax, boundsMin, boundsMax) === 100;

export const shouldTrackYZoomChange = (
    previous: [number, number],
    selected: [number, number],
    bounds: { min: number; max: number },
) => {
    if (previous[0] === selected[0] && previous[1] === selected[1]) {
        return false;
    }

    if (isFullYZoomRange(selected[0], selected[1], bounds.min, bounds.max)) {
        return false;
    }

    return getYZoomPercentage(selected[0], selected[1], bounds.min, bounds.max) < 100;
};
